<template>
    <div class="">
            <div class="container-fluid justify-content-center" v-if="galleryParador">
                <div class="row justify-content-center">
                    <div class="col-sm-9 col-12">
                        <div class="justify-content-center">
                            <div class="card-header pb-0 pt-3 text-center justify-content-center">
                                <h2 style="color: #d4041b !important;">Servicios</h2>
                            </div>
                            <div class="containerm">
                                <div class="row">
                                    <div class="col-sm-3 mt-4 d-flex justify-content-center align-items-center" v-for="image in galleryParador.images_url" :key="image">
                                        <div class="image rounded-2 text-center"> <img :src="image" alt=""> 
                                            <small>{{ image.split('/')[image.split('/').length - 1].split('.')[0].replace(/-/g, ' ').toUpperCase() }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
  
<script>
export default {
  name: "paradero",
  data() {
    return {
        galleryParador:undefined,
    };
  },
  created() {
    this.plain
    .get(`/galleriesName?title=Parador el Potosino (Servicios)`)
    .then((response) => {
      this.galleryParador= response.data
      // console.log(response);
      })
      .catch((err) => {
      this.galleryParador = undefined;
      console.log(err);
    })
  },
};
</script>
  
<style scoped>
.containerm {
    min-height: 30vh;
    overflow: hidden;
    width: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 7%;
    padding-right: 1%;
    position: static;
}

.image {
    overflow: hidden;
    height: 200px;
    width: 200px;
    position: relative;
    cursor: pointer;
    box-shadow: 0 0 25px 1px rgba(0, 0, 0, .3);
    transition: .5s;
    background-color: #555
    ra
}

.image:after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 10%;
    left: 50%;
    width: 500px;
    height: 500px;
    transform: translate(-140%, -50%);
    background-color: #d4041b;
    opacity: 0.8;
    border-radius: 50%;
    transition: .8s
}

.image:hover:after {
    transform: translate(-50%, -50%)
}

.image:hover img {
    transform: translate(-50%, -50%) scale(1.3) rotate(20deg)
}

img {
    position: absolute;
    height: 110%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: .8s
}

small {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-2000px, -50%);
    color: #fff;
    transition: .8s;
    transition-timing-function: ease-in
}

.image:hover small {
    transform: translate(-50%, -50%);
    transition-timing-function: ease
}
.card{
  position: static;
}

.container-fluid{
  position: static;
}


</style>